import { useState, type FormEvent } from 'react';
import { useAuth } from '../../context/AuthContext';
import { isFirebaseConfigured } from '../../lib/firebase';
import btn from '../../styles/buttons.module.css';
import styles from './Login.module.css';

export function Login() {
  const { signInWithEmail, signInWithGoogle } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setError('');
    setBusy(true);
    try {
      await signInWithEmail(email, password);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Sign-in failed.');
    } finally {
      setBusy(false);
    }
  };

  const handleGoogle = async () => {
    setError('');
    setBusy(true);
    try {
      await signInWithGoogle();
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Sign-in failed.');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className={styles.page}>
      <div className={styles.glow} />
      <div className="grain" />
      <div className={styles.card}>
        <div className={styles.brand}>
          <img src="/mithril-logo.svg" alt="Mithril Media" className={styles.logo} />
          <div>
            <div className={styles.title}>Studio Board</div>
            <div className={styles.tagline}>Stay curious. And ship.</div>
          </div>
        </div>

        {!isFirebaseConfigured && (
          <p className={styles.notice}>
            Firebase isn’t configured yet. Add your project keys to
            <code> .env.local</code> to enable sign-in.
          </p>
        )}

        <form className={styles.form} onSubmit={handleSubmit}>
          <div>
            <div className={styles.label}>Email</div>
            <input
              className={styles.input}
              type="email"
              autoComplete="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@mithrilmedia.io"
              required
            />
          </div>
          <div>
            <div className={styles.label}>Password</div>
            <input
              className={styles.input}
              type="password"
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
              required
            />
          </div>

          {error && <p className={styles.error}>{error}</p>}

          <button
            type="submit"
            className={`${btn.btn} ${btn.cta} ${styles.submit}`}
            disabled={busy}
          >
            {busy ? 'Signing in…' : 'Sign in →'}
          </button>
        </form>

        <div className={styles.divider}>or</div>

        <button
          type="button"
          className={`${btn.btn} ${btn.ghost} ${styles.google}`}
          onClick={() => void handleGoogle()}
          disabled={busy}
        >
          Continue with Google
        </button>
      </div>
    </div>
  );
}
